import { MapperConnectionReference } from 'app/model/adfDataMapper/mapperConnectionReference';
import { IMapperTable } from './IMapperTable';

export class MapperAttributeReference {
    public tableConnectionReference: MapperConnectionReference;
    public table: IMapperTable;
    public columnName: string;

    constructor(name: string, table: IMapperTable, entityConnectionReference: MapperConnectionReference) {
        this.table = table;
        this.columnName = name;
        this.tableConnectionReference = entityConnectionReference;
    }

    public isValidReference(validateEntity: boolean = true): boolean {
        return !!this.columnName
            && validateEntity === true ? !!this.table?.tableName : true
            && !!this.tableConnectionReference
            && this.tableConnectionReference.isValidReference();
    }
}
